import { fetchLibraDietApiData } from './apiData'
import { localizePath, initRequestOptions } from '../utils/api'

const path = '/activity_kinds'

export const activityKindsIndex =
	(locale, accessToken, filter = {}, page = {}) =>
	(dispatch) => {
		const endpoint = localizePath(locale, path)
		const options = initRequestOptions({ accessToken })
		const params = { filter, page }

		return dispatch(fetchLibraDietApiData({ endpoint, options, params }))
	}
